import React from 'react';
import ButtonShadow from '../../elements/ButtonShadow';
import InputShadow from '../../elements/InputShadow';

const ModalSendPushClient = ({ values, _sendPushNotification, handleChange, token, setCount, count }) => {
    return (
        <div className="modal fade" id="modalSendPushClient" >
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="modalSendPushClient">Envoyer un message push</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => setCount(count + 1)}></button> 
                    </div>
                    <div className="modal-body">

                        {/* TITRE */}
                        <InputShadow value={values.title} onChange={handleChange} placeholder='Titre' name='title' />

                        {/* TITRE */}
                        <InputShadow value={values.message} onChange={handleChange} placeholder='Message' name='message' />

                        {/* BUTTON ENVOYER */}
                        <ButtonShadow 
                            title='Envoyer' 
                            onClick={() => [_sendPushNotification(token,values.title,values.message), setCount(count + 1)]} 
                            disabled={values.title && values.message ? false : true} 
                        />

                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalSendPushClient